import React from 'react';
import takeOffMarker from './assets/takeoff.svg';
import { Marker } from '@react-google-maps/api';
import { TakeOffMarkerProps } from './types';

const TakeOffMarker: React.FC<TakeOffMarkerProps> = (props) => {
  return (
    <Marker 
      icon={{ 
        url: takeOffMarker, 
        scaledSize: new window.google.maps.Size(30, 30), 
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(15, 15),
      }}
      {...props} />
  );
};

export default TakeOffMarker;